import React from "react";
import ParsedHTML from '../ParsedHTML'
// import {} from '../../../styles'
import {
  WYSIWYGContentContainer
} from './styles'
import { Color } from "../../../styles";

export default function WYSIWYGContent({
  content,
  slimline = true,
  darkTheme = false,
  marginBottom = '0px',
  headingColor = Color.blue,
}) {
  return (<WYSIWYGContentContainer
    slimline={slimline}
    darkTheme={darkTheme}
    marginBottom={marginBottom}
    headingColor={headingColor}
  >
    <ParsedHTML content={content} />
  </WYSIWYGContentContainer>);
}
